export default {"src":"/_next/static/media/telegram-logo-hover.8174c715.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};